import { Injectable, Type } from '@angular/core';

import {
  BeehiveApiService,
  castDataToEntity,
  sanitizeDeeper,
} from '../beehive-api.service';
import { Child } from './child.model';
import { map, Observable, of, tap } from 'rxjs';
import {
  DiscountSubscription,
  DiscountSubscriptionType,
} from '../discount/lib/discount.interfaces.js';
import { ApiResponse } from '../api.interfaces';
import { Registration } from '../registration/registration.model';
import { patchRegistration } from '../registration/registration.util';
import { ApiResource } from '../api-resource';
import { ApiQueryParams } from '../api.operators';

@Injectable({
  providedIn: 'root',
})
export class ChildService extends BeehiveApiService<Child> {
  protected entityType = Child;
  protected endpoint = 'children';

  updateParents(id: string, parents: Child['parents']): Observable<Child> {
    const url = this.getUrl(encodeURIComponent(id), 'parents');
    const sanitized = sanitizeDeeper(parents);
    const data = sanitized.map((item: { id: string }) => ({
      customer: { id: item.id },
    }));

    return this.http
      .put<ApiResponse<Child>>(url, { data })
      .pipe(
        map((response) => castDataToEntity(this.entityType, response.data)),
      );
  }

  getDiscountSubscriptions(child: Child): Observable<DiscountSubscription[]> {
    return of([
      { type: DiscountSubscriptionType.UitPas, active: false },
      { type: DiscountSubscriptionType.IVV, active: true },
    ]);
    // todo: connect to api
    // return this.getMany([
    //   encodeURIComponent(child.id),
    //   'discount-subscriptions',
    // ]);
  }

  getRegistrations(child: Child) {
    return this.listRelated(child.id, 'registrations', Registration, {
      page: { limit: 100 },
    });
  }

  override listRelated<T extends ApiResource<any>>(
    id: string,
    endpoint: string,
    relatedType: Type<T>,
    params?: ApiQueryParams<T>,
  ): Observable<T[]> {
    let related = super.listRelated(id, endpoint, relatedType, params);
    if (endpoint === 'registrations') {
      related = related.pipe(
        tap((resources: any[]) => resources.forEach(patchRegistration)),
      );
    }
    return related;
  }
}
